import { MAX_NAME_LENGTH } from '@/shared/config';
import { InferType, object, string } from '@/shared/config/yup';

export const editInfoFormSchema = object({
  firstName: string().required().max(MAX_NAME_LENGTH),
  lastName: string().required().max(MAX_NAME_LENGTH),
});

export type EditInfoFormPayload = InferType<typeof editInfoFormSchema>;
